<template>
    <div class="tabs_content baseInfo clearfix">
        
        <!-- <div class="title1">专利基本信息</div> -->
        <div class="info_left">
            <div class="img_icon">
                <div class="bg_img">
                    <img src="../../../assets/images/icons/empty_icon.svg" alt="">
                    <div class="text">该专利无附图</div>
                </div>
                <img :src="$store.state.baseUrl + detailInfo.bigImagePath" alt="">
            </div>
            <div class="marb8 tit2">著录项</div>
            <div class="line_style">
                <div class="label">专利标题</div>
                <div class="text">{{detailInfo.title}}</div>
            </div>
            <div class="line_style">
                <div class="label">申请号</div>
                <div class="text">{{detailInfo.applicationNumber}}</div>
            </div>
            <div class="line_style">
                <div class="label">公开（公告）号</div>
                <div class="text">{{detailInfo.documentNumber}}</div>
            </div>
            <div class="line_style">
                <div class="label">申请日</div>
                <div class="text">{{detailInfo.applicationDate}}</div>
            </div>
            <div class="line_style">
                <div class="label">公开（公告）日</div>
                <div class="text">{{detailInfo.documentDate}}</div>
            </div>
            <div class="line_style">
                <div class="label">当前申请（专利权）人</div>
                <div class="text">
                    <span v-for="(item,index) in detailInfo.applicant" :key="index">
                        {{item}}
                    </span>
                </div>
            </div>
            <div class="line_style">
                <div class="label">第一申请（专利权）人</div>
                <div class="text">{{detailInfo.firstApplicant}}</div>
            </div>
            <div class="line_style">
                <div class="label">发明人</div>
                <div class="text">
                    <span v-for="(item,index) in detailInfo.inventor" :key="index">
                        {{item}}
                    </span>
                </div>
            </div>
            <div class="line_style">
                <div class="label">第一发明人</div>
                <div class="text">{{detailInfo.firstInventor}}</div>
            </div>
            <div class="line_style" v-if="detailInfo.mainIpc">
                <div class="label">IPC分类号</div>
                <div class="text">{{detailInfo.mainIpc}}</div>
            </div>
            <div class="line_style marb20" v-if="detailInfo.applicantAddress">
                <div class="label">申请地址</div>
                <div class="text">{{detailInfo.applicantAddress}}</div>
            </div>
            <div class="line_style" v-if="false&&detailInfo.grantDate">
                <div class="label">授权日</div>
                <div class="text">{{detailInfo.grantDate}}</div>
            </div>
            <div class="line_style" v-if="false&&detailInfo.agency">
                <div class="label">代理机构</div>
                <div class="text">{{detailInfo.agency}}</div>
            </div>
            <div class="line_style" v-if="false&&detailInfo.agent">
                <div class="label">代理人</div>
                <div class="text">
                    <span v-for="(item,index) in detailInfo.agent" :key="index">
                        {{item}}
                    </span>
                </div>
            </div>
            <div class="line_style2" v-if="detailInfo.summary">
                <div class="tit2">摘要</div>
                <div class="desp2 line24">{{detailInfo.summary}}</div>
            </div>
            <div class="line_style2" v-if="detailInfo1.hotWords&&detailInfo1.hotWords.length>0">
                <div class="tit2">拓展内容</div>
                <div class="desp2">
                    <span class="key_name">文章关键词：</span>
                    <span class="blue_name" v-for="(item,index) in detailInfo1.hotWords" :key="index" @click="goSearch('key',item)">
                        {{item}}
                    </span>
                </div>
            </div>
            <div class="line_style2" v-if="detailInfo1.ipcMap">
                <div class="tit2">IPC结构图谱</div>
                <div class="desp2">
                    <div class="line_name" v-for="(item,index) in detailInfo1.ipcMap" :key="index" @click="goSearch('ipc',item.code)">
                        <span class="name" :style="{'padding-left': 10*index+'px'}">{{item.code}}</span>
                        <span class="name tit_overflow">{{item.name}}</span>
                    </div>
                </div>
            </div>
            <div class="line_style2" v-if="detailInfo1.hotWords&&detailInfo1.hotWords.length>0">
                <div class="tit2">拓展内容</div>
                <div class="desp2">
                    <span class="key_name">文章关键词：</span>
                    <span class="blue_name" v-for="(item,index) in detailInfo1.hotWords" :key="index" @click="goSearch('key',item)">
                        {{item}}
                    </span>
                </div>
            </div>
            <div class="line_style2" v-if="detailInfo1.ipcMap">
                <div class="tit2">IPC结构图谱</div>
                <div class="desp2">
                    <div class="line_name" v-for="(item,index) in detailInfo1.ipcMap" :key="index" @click="goSearch('ipc',item.code)">
                        <span class="name" :style="{'padding-left': 10*index+'px'}">{{item.code}}</span>
                        <span class="name tit_overflow">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="info_right img_icon hand" @click="showImg" v-if="false">
            <img :src="$store.state.baseUrl + detailInfo.bigImagePath" alt="">
        </div>
        <v-row v-if="false">
            <v-col sm="3">摘要</v-col>
            <v-col sm="9">{{detailInfo.summary}}</v-col>
        </v-row>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    name:"pantentBase",
    props:{
        pid:{
            id:''
        }
    },
    data(){
        return{            
             detailInfo: {},
             detailInfo1:{}
        }
    },
    created(){
        this.getDetail(this.pid.id)
    },
    watch:{
     pid:{
          handler(n,o){
            
              this.getDetail(n.id)
          },
          deep:true
          
     }
    },
    methods:{
        ...mapActions('search',['getPatentInfo']),
       getDetail(val) {
             let data = {
                params: {
                    udn: val
                }
            }
            let _this = this
            this.getPatentInfo({data: data,handle(res) {
                    _this.detailInfo1 = res
                    console.log(res)
                    let info = res.patent ? res.patent: {}
                    _this.detailInfo = info
            }})
        },
    }
}
</script>